// Lane B3's one mount on the V1 screen round page (`#requisitions/<R>/candidates/<aid>/rounds/1`): the Step 8
// Recruiter screen card and, for a candidate Pending HM Selection, the Step 9 HM interview selection card — inside
// the design system's root, under the page's heading row and above the V1 scheduling and screen-form sections, which
// stay below outside `.mc` until the scheduling engine replaces them. Inside the shell's McRoot it is a plain .mc box
// (McPage), so the page keeps one root: one settle signal and the root's frozen instant under capture.

import { Stack } from "@/mc";
import { McPage } from "@/shell/page";
import { HmSelectionCard } from "./HmSelectionCard";
import { RecruiterScreenCard } from "./RecruiterScreenCard";

export function B3RoundCards({ rid, aid }: { rid: string; aid: string }) {
  return (
    <McPage>
      <Stack gap={12}>
        <RecruiterScreenCard rid={rid} aid={aid} />
        <HmSelectionCard rid={rid} aid={aid} />
      </Stack>
    </McPage>
  );
}
